import React, { useState, useContext, ReactNode } from "react";
import ConfigContext from "contexts/ConfigContext";
import StyledButton from "components/buttons/StyledButton";
import BuyNowDialog from "./dialog/BuyNowDialog";
import EditionType from "models/EditionType";

interface IProps {
    edition: EditionType;
    dialogText?: ReactNode;
    children?: ReactNode;
}

export default function BuyNowButton(props: IProps) {
    const { edition, dialogText, children = "Buy Now", ...rest } = props;
    const [open, setOpen] = useState(false);
    const config = useContext(ConfigContext);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    if (typeof config === "undefined") return null;

    const { purchaseLinks } = config;

    const editionPurchaseLinkConfig = purchaseLinks[edition];

    if (typeof editionPurchaseLinkConfig === "undefined") return null;

    return (
        <>
            <StyledButton style={{ zIndex: 101 }} onClick={handleClickOpen}>
                {children}
            </StyledButton>

            <BuyNowDialog
                open={open}
                onClose={handleClose}
                editionPurchaseLinkConfig={editionPurchaseLinkConfig}
                dialogText={dialogText}
                {...rest}
            />
        </>
    );
}
